import Backdrop from "@mui/material/Backdrop";
import { useEffect, useRef, useState } from "react";
import greyDots from "../../../assets/gif/grey-three-dot.gif";
import yellowDots from "../../../assets/gif/yellow-three-dot.gif";
import redDots from "../../../assets/gif/red-three-dot.gif";
import { Stack, Typography } from "@mui/material";
import { Colors } from "../../../styles/constant";
import "./CustomLoader.scss";

const data = [
  {
    title: "Loading your ABCD dashboard",
    subtitle: "This may take a few seconds",
    gif: greyDots,
  },
  {
    title: "Getting things ready",
    subtitle: "This may take a few seconds",
    gif: yellowDots,
  },
  {
    title: "Almost there",
    subtitle: "This may take a few seconds",
    gif: redDots,
  },
];

const TITLE_FADE_DURATION = 300;
const TITLE_INTERVAL = 5000;
const backdropStyles = {
  height: "100%",
  width: "100%",
  padding: "0rem",
  margin: "0rem",
  zIndex: 9999,
  backgroundColor: "#FFFFFFB2",
  backdropFilter: "blur(5px)",
};

const CustomLoader = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const titleSwapTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );
  const titleFadeFrameRef = useRef<number | null>(null);

  useEffect(() => {
    const initialFrame = window.requestAnimationFrame(() => {
      setIsTitleVisible(true);
    });
    const interval = setInterval(() => {
      setIsTitleVisible(false);
      titleSwapTimeoutRef.current = setTimeout(() => {
        setCurrentIndex((previousIndex) => (previousIndex + 1) % data.length);
        titleFadeFrameRef.current = window.requestAnimationFrame(() => {
          setIsTitleVisible(true);
        });
      }, TITLE_FADE_DURATION);
    }, TITLE_INTERVAL);
    return () => {
      window.cancelAnimationFrame(initialFrame);
      clearInterval(interval);
      if (titleSwapTimeoutRef.current) {
        clearTimeout(titleSwapTimeoutRef.current);
      }
      if (titleFadeFrameRef.current !== null) {
        window.cancelAnimationFrame(titleFadeFrameRef.current);
      }
    };
  }, []);

  const displayData = data[currentIndex];

  return (
    <Backdrop open={true} style={backdropStyles}>
      <Stack
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        rowGap="0.5rem"
      >
        <img src={displayData.gif} alt="gif" style={{ width: "6rem" }} />
        <Stack flexDirection="column" alignItems="center" gap="0.5rem">
          <div
            className={`custom-loader-title ${
              isTitleVisible ? "is-visible" : ""
            }`}
          >
            <Typography variant="h3" color={Colors.black}>
              {displayData.title}
            </Typography>
          </div>
          <Typography
            variant="subtitle2"
            color={Colors.textGray}
            fontWeight="400"
          >
            {displayData.subtitle}
          </Typography>
        </Stack>
      </Stack>
    </Backdrop>
  );
};

export default CustomLoader;
